import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, MapPin, Phone, Mail } from "lucide-react";

const SHOP_LINKS = [
  { label: "All Products", to: "/shop/all" },
  { label: "Shop by Category", to: "/shop" },
  { label: "Flowers", to: "/category/flower-strains" },
  { label: "Pre-Rolls", to: "/category/pre-rolls" },
  { label: "Edibles", to: "/category/edibles" },
  { label: "Vapes", to: "/category/cartridges" },
  { label: "Concentrates", to: "/category/concentrates" },
  { label: "Deals", to: "/category/special-deals" },
];

const CUSTOMER_LINKS = [
  { label: "Contact", to: "/about#contact" },
  { label: "FAQ", to: "/faq" },
  { label: "How to Order", to: "/how-to-order" },
  { label: "Delivery", to: "/delivery" },
];

const COMPANY_LINKS = [
  { label: "About", to: "/about" },
  { label: "DC Cannabis Laws", to: "/faq#laws" },
  { label: "Privacy Policy", to: "/faq#privacy" },
  { label: "Terms of Service", to: "/faq#terms" },
];

const AREA_LINKS = [
  { label: "All Service Areas", to: "/service-areas" },
  { label: "Weed Delivery DC", to: "/weed-delivery-dc" },
  { label: "Edibles DC", to: "/thc-edibles-dc" },
  { label: "Shaw", to: "/weed-delivery-shaw" },
  { label: "Georgetown", to: "/weed-delivery-georgetown" },
  { label: "Navy Yard", to: "/weed-delivery-navy-yard" },
];

export default function Footer() {
  return (
    <footer className="relative bg-brand-ink text-neutral-300 grain" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-2">
            <img src="/logo.webp" alt="Farmacy District DC" className="h-12 w-auto" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-neutral-400">
              Washington DC's trusted cannabis dispensary — premium flower, edibles, vapes and concentrates with fast,
              discreet delivery across the District.
            </p>
            <div className="mt-6 space-y-2.5 text-sm">
              <a href="tel:+12029134523" className="flex items-center gap-2.5 transition-colors hover:text-brand-lime" data-testid="footer-phone">
                <Phone className="h-4 w-4 text-brand-lime" /> (202) 913-4523
              </a>
              <a href="mailto:Info@farmacydistrictdc.com" className="flex items-center gap-2.5 transition-colors hover:text-brand-lime" data-testid="footer-email">
                <Mail className="h-4 w-4 text-brand-lime" /> Info@farmacydistrictdc.com
              </a>
              <p className="flex items-center gap-2.5" data-testid="footer-address">
                <MapPin className="h-4 w-4 text-brand-lime" /> 1100 New Jersey Ave SE, Washington, DC
              </p>
            </div>
            <div className="mt-6 flex gap-3">
              {[
                { icon: Instagram, label: "Instagram" },
                { icon: Facebook, label: "Facebook" },
                { icon: Twitter, label: "Twitter" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  data-testid={`social-${s.label.toLowerCase()}`}
                  className="rounded-full border border-white/15 p-2.5 transition-colors hover:border-brand-lime hover:text-brand-lime"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
          {[
            { title: "SHOP", links: SHOP_LINKS },
            { title: "CUSTOMER", links: CUSTOMER_LINKS },
            { title: "COMPANY", links: COMPANY_LINKS },
            { title: "DELIVERY AREAS", links: AREA_LINKS },
          ].map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white">{col.title}</h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-neutral-400 transition-colors hover:text-brand-lime"
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 border-t border-white/10 pt-8">
          <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
            <p className="text-[11px] leading-relaxed text-neutral-500" data-testid="footer-compliance">
              PICK UP AND DELIVERY ONLY · Initiative 71 Compliant Gifting · For use only by adults 21 years of age and
              older · Keep out of reach of children.
            </p>
            <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border-2 border-brand-lime text-xs font-black text-brand-lime" data-testid="footer-21-badge">
              21+
            </span>
          </div>
          <p className="mt-6 text-xs text-neutral-500">© 2026 Farmacy District DC. All rights reserved.</p>
          <p className="mt-3 text-xs text-neutral-500">
            Website developed &amp; SEO by{" "}
            <a
              href="https://webnehtech.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-developer-credit"
              className="animate-glow-pulse font-bold tracking-wide text-brand-lime transition-colors hover:text-brand-limehover"
            >
              webnehtech.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
